export default "__VITE_ASSET__Cxt0dQYq__"